import React, { Component } from "react";
import $ from "jquery";
import { ButtonContainer } from "../Button/Button";

$(function() {
  $("#btnsubmit").on("click", function() {
    $(this)
      .val("Please fill form ...")
      .attr("disabled", "disabled");
    $("#theform").submit();
  });
});

class Upload extends Component {
  constructor(props, context) {
    super(props, context);
    // this.eosio = new EOSIOClient("smartshop");
    this.state = {
      form: {
        key: "",
        p_name: "",
        price: "",
        max_quantity: "",
        category: "fastFood",
        info: ""
      }
    };
    // Bind functions
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleChange(event) {
    const { name, value } = event.target;
    const { form } = this.state;

    this.setState({
      form: {
        ...form,
        key: localStorage.getItem("account_name"),
        [name]: value
      }
    });
  }

  // Handle form submission to call api
  handleSubmit(event) {
    event.preventDefault();
    const { form } = this.state;
    this.setState({ loading: true });
    //console.log("gyin", form);
     this.props.eosio2.sendProductData(form,this.props.tokenName); //this.eosio.sendProductData(form)
    setTimeout(() => {
      this.setState({ loading: false });
    }, 4000);
  }

  uploadImage() {

    var progressBar = document.getElementById("progress"),
      display = document.getElementById("display");
    const r = new XMLHttpRequest();
    const d = new FormData();
    const e = document.getElementsByClassName("input-image")[0].files[0];
    var u;

    d.append("image", e);

    r.open("POST", "https://api.imgur.com/3/image/");

    r.setRequestHeader("Authorization", `Client-ID 77c67793d561120`);
    r.upload.onprogress = function(e) {
      if (e.lengthComputable) {
        progressBar.max = e.total;
        progressBar.value = e.loaded;
        display.innerText = Math.floor((e.loaded / e.total) * 100) + "%";
      }
    };
    r.upload.onloadstart = function(e) {
      progressBar.value = 0;
    };
    r.upload.onloadend = function(e) {
      progressBar.value = e.loaded;
    };

    // r.onProgress()

    let pr;
    r.onreadystatechange = function() {
      pr = new Promise((resolve, reject) => {
        if (r.status === 200 && r.readyState === 4) {
          let res = JSON.parse(r.responseText);
          u = `https://i.imgur.com/${res.data.id}.png`;

          const d = document.createElement("div");
          d.className = "image";
          document.getElementsByTagName("body")[0].appendChild(d);

          // const i = document.createElement('img')
          // i.className = 'image-src'
          // i.src = u
          // document.getElementsByClassName('image')[0].appendChild(i)

          const a = document.createElement("a");
          a.className = "image-link";
          a.href = u;
          document.getElementsByClassName("image")[0].appendChild(a);

          const p = document.createElement("p");
          p.className = "image-url";
          p.innerHTML = u;
          document.getElementsByClassName("image-link")[0].appendChild(p);

          resolve();
        }
      });

      pr.then(() => {
 
        console.log("done");
        
let   counter=document.getElementsByClassName("image-url").length
       for(let i=0; i<counter;i++)
        {
        localStorage.setItem(
           "Img_Url",
           document.getElementsByClassName("image-url")[i].innerHTML
         );
        }

       // console.log("local storage :",localStorage.getItem("Img_Url"))
       // console.log(document.getElementsByClassName("image-url").length)
      });
    };
    r.send(d);
  }

  move() {
    var elem = document.getElementById("myBar");
    var width = 10;
    var id = setInterval(frame, 10);
    function frame() {
      if (width >= 100) {
        clearInterval(id);
      } else {
        width++;
        elem.style.width = width + "%";
        elem.innerHTML = width * 1 + "%";
      }
    }
  }

  render() {
    console.log("tokenName: ",this.props.tokenName)
    console.log("contractName: ",this.props.contractName)
    
    const { form } = this.state;
    const { loading } = this.state;
    localStorage.setItem("Img_Url", "https://i.imgur.com/xRznKWi.png");
    return (
      <>
        <div className="container register">
          <div className="row">
            <div className="col-md-12">
              <div className="tab-content" id="myTabContent">
                <div
                  className="tab-pane fade show active text-align form-new"
                  id="home"
                  role="tabpanel"
                  aria-labelledby="home-tab"
                >
                  <h3 className="register-heading">
                    <b>Product Data </b>
                  </h3>
                  <div className="row register-form">
                    <div className="col-md-12">
                      <form onSubmit={this.handleSubmit}>
                        <div className="form-group">
                          <input
                            type="text"
                            name="key"
                            className="form-control"
                            placeholder="Your Name *"
                            value={localStorage.getItem("account_name")}
                            disabled
                            readOnly
                            required
                          />
                        </div>
                        <div className="form-group">
                          <input
                            type="text"
                            name="p_name"
                            className="form-control"
                            placeholder="Product Name *"
                            value={form.p_name}
                            onChange={this.handleChange}
                            required
                          />
                        </div>
                        <div className="form-group">
                          <input
                            type="text"
                            name="price"
                            className="form-control"
                            placeholder={"Price in " + this.props.tokenName}
                            value={form.price}
                            onChange={this.handleChange}
                            required
                          />
                        </div>
                        <div className="form-group">
                          <input
                            type="text"
                            name="max_quantity"
                            className="form-control"
                            placeholder="Maximum Quantity *"
                            value={form.max_quantity}
                            onChange={this.handleChange}
                            required
                          />
                        </div>
                        <div className="form-group">
                          <label>
                            Pick your Category:
                            </label>
                            <select
                              name="category"
                              className="form-control"
                              value={this.state.value}
                              onChange={this.handleChange}
                            >
                              <option value="fastFood">Fast Food</option>
                              <option value="snacks">Snacks</option>
                              <option value="drinks">Drinks</option>
                              
                            </select>
                       
                        </div>
                        <div className="form-group">
                          <input
                            type="text"
                            name="info"
                            className="form-control"
                            placeholder="Information *"
                            value={form.info}
                            onChange={this.handleChange}
                            required
                          />
                        </div>

                        <div className="form-group">
                          <input
                            type="file"
                            className="input-image"
                            onChange={this.uploadImage.bind(this)}
                          />
                        </div>

                        <div className="form-group">
                          <progress id="progress" value="0" />
                          <span id="display" />
                        </div>
    
                        <ButtonContainer
                          //id="btnsubmit"
                            type="submit"
                            name="submit"
                            className="btnContactSubmit"
                            value="Submit"
                            disabled={loading}>
                            {loading && (
                              <i
                                className="fa fa-refresh fa-spin"
                                style={{ marginRight: "5px" }}
                              />
                            )}
                            {loading && <span>Loading... </span>}
                            {!loading && <span>Submit</span>}
                   
                          </ButtonContainer>
                        {/* <a href="ForgetPassword.php" className="btnForgetPwd" value="Login">Forget Password?</a> */}
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default Upload;
